// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ri-0";